// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mm-0";
export var buttonContainer = "_mm-3";
export var cancelButton = "_mm-4";
export var headerSection = "_mm-6";
export var headerTitle = "_mm-9";
export var messageSideLeft = "_mm-1";
export var messageSideRight = "_mm-2";
export var orderNumberContainer = "_mm-7";
export var orderNumberLabel = "_mm-8";
export var submitButton = "_mm-5";